function initCta() {
  if ($('.cta-module').length == 0) {
    return false;
  }

  $('.cta-module').each(function () {
    if ($(this).is(':last-child')) {
      $(this).addClass('cta-module-last');
    }
  });
}

export { initCta }



// WEBPACK FOOTER //
// ./scripts/modules/cta.js